<template>
  <div>
    <nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
      <router-link to="/index" class="logo-dashboard-navbar text-white text-decoration-none navbar-brand col-sm-3 col-md-2 mr-0">Gentleman</router-link>
      <ul class="navbar-nav px-3">
        <li class="nav-item text-nowrap">
          <a class="nav-link" href="#" @click.prevent="signout">登出</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'DashboardNavbar',
  methods: {
    signout () {
      const api = `${process.env.VUE_APP_API_PATH}/logout`
      const vm = this
      this.$http.post(api).then((response) => {
        console.log(response.data)
        if (response.data.success) {
          vm.$router.push('/login')
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  // @import "../assets/all";
  .logo-dashboard-navbar {
    font-family: Baskerville;
  }
</style>
